import React, { ReactNode } from "react";
import InfoCard from "./InfoCard";

// Props interfaces for Card, CardTitle, and CardDescription
interface CardProps {
  children?: ReactNode; // Optional additional content
  className?: string;   // Added className prop
  noPadding?: boolean;  // Option to remove padding
  onClick?: () => void; // Click handler for interactive cards
}

interface CardTitleProps {
  children: ReactNode;
  className?: string;   // Added className prop
}

interface CardDescriptionProps {
  children: ReactNode;
  className?: string;   // Added className prop
}

interface CardHeaderProps {
  children: ReactNode;
  className?: string;
}

interface CardContentProps {
  children: ReactNode;
  className?: string;
}

// Card Component
const Card: React.FC<CardProps> = ({ children, className = "", noPadding = false, onClick }) => {
  return (
    <div 
      className={`card-surface rounded-2xl ${!noPadding ? 'p-5 sm:p-6' : ''} ${className}`}
      onClick={onClick}
    >
      {children}
    </div>
  );
};

// CardHeader Component
const CardHeader: React.FC<CardHeaderProps> = ({ children, className = "" }) => {
  return (
    <div className={`mb-4 ${className}`}>
      {children}
    </div>
  );
};

// CardContent Component
const CardContent: React.FC<CardContentProps> = ({ children, className = "" }) => {
  return (
    <div className={className}>
      {children}
    </div>
  );
};

// CardTitle Component
const CardTitle: React.FC<CardTitleProps> = ({ children, className = "" }) => {
  return (
    <h4 className={`mb-1 font-medium text-gray-800 text-xl dark:text-white/90 ${className}`}>
      {children}
    </h4>
  );
};

// CardDescription Component
const CardDescription: React.FC<CardDescriptionProps> = ({ children, className = "" }) => {
  return <p className={`text-sm text-gray-500 dark:text-gray-400 ${className}`}>{children}</p>;
};

// Named exports for better flexibility
export { Card, CardHeader, CardContent, CardTitle, CardDescription, InfoCard }; 